// removed by extract-text-webpack-plugin
module.exports = {"App":"VPwrNWUWaWFwHEF-1CX8","ProgressBar":"Ayf9GQw2pP8VHzM0xKsV3","page":"QkrKsJQSzC5RNzbYUp31y"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.scss
// module id = 2890
// module chunks = 0